// TEXPROCILRegistration.jsx
import React from "react";

export default function TEXPROCILRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            TEXPROCIL Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            TEXPROCIL Registration for Textile Exporters
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists textile exporters with TEXPROCIL
            Registration to obtain RCMC and access export promotion benefits for
            cotton textiles, yarns, fabrics, and made-ups under Foreign Trade Policy.
          </p>
          <p className="text-gray-700">
            Through the DGFT e-RCMC digital platform, the process ensures
            exporters qualify for Member Exporter status (₹2 Cr+ turnover) or
            Registered Textile Exporter category with complete documentation support.
          </p>
        </div>

        {/* Right: Image (TEXPROCIL PERFECT MATCH - Cotton textiles fabrics yarn textile manufacturing export) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5848421/pexels-photo-5848421.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Cotton textiles yarns fabrics ready for TEXPROCIL certified export"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* PROFESSIONAL SUPPORT & DOCUMENTS SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Professional compliance support */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Professional Compliance Support by Hawkins &amp; Brooks
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks provides complete assistance for TEXPROCIL
              membership through DGFT's e-RCMC platform for cotton textile exporters.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  IEC verification and e-RCMC application preparation through DGFT
                  common digital platform with TEXPROCIL membership selection.
                </li>
                <li>
                  Export turnover certification support for Member Exporter (₹2 Cr+)
                  or Registered Textile Exporter category eligibility.
                </li>
                <li>
                  Coordination with TEXPROCIL for document scrutiny, membership
                  approval, and digital RCMC certificate issuance (valid 5 years).
                </li>
                <li>
                  Renewal management and compliance advisory for continuous export
                  promotion council benefits and FTP scheme eligibility.
                </li>
              </ul>
            </div>
          </div>

          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for TEXPROCIL Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks assists in compiling TEXPROCIL membership
              documents required for e-RCMC application processing.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Valid Import Export Code (IEC) certificate.</li>
                <li>PAN card of business entity and authorised signatory.</li>
                <li>
                  Business incorporation documents (Partnership Deed, MOA/AOA,
                  Incorporation Certificate, or Proprietorship Declaration).
                </li>
                <li>
                  CA certificate confirming export turnover (₹2 Cr+ for Member
                  Exporter) or Udyam/MSME certificate (for RTE category).
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in textile export compliance with proven success
              in securing TEXPROCIL RCMC for manufacturers and merchant exporters.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Textile Export Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete knowledge of TEXPROCIL membership categories, cotton
                  textile export promotion, and Foreign Trade Policy benefits.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Smooth Registration Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Professional e-RCMC platform management, document verification,
                  and TEXPROCIL coordination for timely membership approval.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Advisory Support
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end guidance from eligibility assessment through RCMC
                  issuance, export promotion events, and scheme benefit access.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="flex flex-col justify-center">
            <div className="bg-gray-50 border border-yellow-100 rounded-2xl p-6 shadow-sm">
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                Access TEXPROCIL Export Benefits
              </h3>
              <p className="text-gray-700 mb-5">
                Connect with Hawkins &amp; Brooks to complete your TEXPROCIL
                Registration and unlock RCMC benefits, export promotion support,
                and Foreign Trade Policy incentives for cotton textile exports.
              </p>
              <div className="flex flex-wrap gap-3">
                <a
                  href="/contact"
                  className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
                >
                  Get Consultation
                </a>
                <a
                  href="tel:+919217468906"
                  className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
                >
                  Call Hawkins &amp; Brooks
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
